// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MvMm","tabsBox":"styles_tabsBox__2vfBL","createButton":"styles_createButton__sybXR"};